/*
 * @Date: 2019-08-21 17:03:34
 * @LastEditors: x
 * @LastEditTime: 2019-10-22 21:06:24
 */
import accountApi from '../../api/account'

const actions = {
  getSuport() {
    return accountApi.getSuport()
  },
  sendLogin(context, data) {
    return accountApi.sendLogin(data)
  },
  sendRegister(context, data) {
    return accountApi.sendRegister(data)
  },
  getIsLogin() {
    return accountApi.getIsLogin()
  },
  getCheckCerOrderState() {
    return accountApi.getCheckCerOrderState()
  },
  getUserKey() {
    return accountApi.getUserKey()
  },
  // 注冊時發送驗證碼
  sendSignRegisterSendSms(context, data) {
    return accountApi.sendSignRegisterSendSms(data)
  },
  // 校验手机号是否注册
  sendCheckTelHadRegister(context, tel) {
    return accountApi.sendCheckTelHadRegister(tel)
  },
  //找回密碼發送驗證碼
  sendSignFindPwdSendSms(context, tel) {
    return accountApi.sendSignFindPwdSendSms(tel)
  },
  //找回密碼
  sendSignFindPwd(context, data) {
    return accountApi.sendSignFindPwd(data)
  },
  getSignRegisterNeedVerCode() {
    return accountApi.getSignRegisterNeedVerCode()
  },
  getCheckVerificationCode(context, data) {
    return accountApi.getCheckVerificationCode(data.verCode, data.verId)
  },
  sendTokenLogin(context,token) {
    return accountApi.sendTokenLogin(token)
  }
}

export default {
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/account.js